// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mwg_effect006 {
  letter-spacing: -0.03em;
  overflow-x: hidden;
  overflow-y: visible;
  background-color: #D8D8D8;
  color: #1E1E1E;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: calc(100 * var(--vw));
}

.mwg_effect006 .pin-height {
  height: 400vh;
}

.mwg_effect006 .container {
  height: 100vh;
  padding: 0;
  width: 100%;
  max-width: calc(100 * var(--vw));
  box-sizing: border-box;
  position: relative;
}

.mwg_effect006 .name {
  position: absolute;
  top: 15vh;
  left: calc(2 * 15px);
}

.mwg_effect006 .left {
  position: absolute;
  left: 0;
  top: 0;
  width: 40%;
  padding-left: calc(15px + calc(1.5 * var(--vw)));
  padding-right: calc(3 * var(--vw));
  z-index: 10;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mwg_effect006 .left .paragraph {
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.9);
}

.mwg_effect006 .video-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
}

.mwg_effect006 .right {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  border-radius: 0;
  z-index: 1;
}

.mwg_effect006 .hero-modern {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  pointer-events: none;
}

.mwg_effect006 .hero-modern-glass {
  margin-left: calc(6 * var(--vw));
  max-width: min(960px, calc(calc(100 * var(--vw)) - calc(12 * var(--vw))));
  padding: clamp(18px, calc(2 * var(--vw)), 28px);
  border-radius: 20px;
  background: rgba(18, 18, 18, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);
  /* backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px); */
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  pointer-events: auto;
}

.mwg_effect006 .hero-modern-inner {
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.mwg_effect006 .hero-modern-eyebrow {
  font-size: clamp(14px, calc(1.1 * var(--vw)), 18px);
  letter-spacing: 0.34em;
  line-height: 1.6;
  text-transform: uppercase;
  opacity: 0.85;
  margin: 0;
}

.mwg_effect006 .hero-modern-title {
  font-size: clamp(35px, calc(3.5 * var(--vw)), 62px);
  line-height: 1.05;
  letter-spacing: 0.025em;
  margin: 0;
}

.mwg_effect006 .hero-modern-subtitle {
  font-size: clamp(16px, calc(1.4 * var(--vw)), 20px);
  line-height: 1.5;
  letter-spacing: 0.02em;
  margin: 0;
  opacity: 0.9;
}

.mwg_effect006 .hero-modern-highlight {
  font-weight: 700;
  color: #CCFF00;
}

.mwg_effect006 .hero-modern-actions {
  display: flex;
  gap: 12px;
  margin-top: 6px;
  pointer-events: auto;
}

.mwg_effect006 .hero-persona-row {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  color: #cfcfe6;
}

.mwg_effect006 .hero-persona-avatars {
  display: flex;
  align-items: center;
}

.mwg_effect006 .hero-persona-avatars img {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.85);
  object-fit: cover;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

.mwg_effect006 .hero-persona-avatars img + img {
  margin-left: -12px;
}

.mwg_effect006 .hero-persona-count {
  min-width: 44px;
  height: 44px;
  border-radius: 999px;
  background: #d9cff7;
  color: #4a3ea3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
}

.mwg_effect006 .hero-persona-text {
  margin: 0;
  font-size: 15px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.85);
}

.mwg_effect006 .hero-modern-metrics {
    display: flex;
    gap: 24px;
    margin-top: 50px;
    opacity: 0.9;
}

.mwg_effect006 .hero-modern-metric {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mwg_effect006 .hero-modern-metric-value {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.mwg_effect006 .hero-modern-metric-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.26em;
}

.mwg_effect006 .hero-modern .navbar-contact-button {
  letter-spacing: 0.08em;
}

.mwg_effect006 .hero-modern-actions .hero-contact-button:not(.hero-demo-button) {
  text-shadow: none;
}

.mwg_effect006 .hero-modern-actions .hero-demo-button {
  background: rgba(18, 18, 18, 0.35);
  color: #CCFF00 !important;
  border: 1px solid rgba(204, 255, 0, 0.5);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mwg_effect006 .hero-modern-actions .hero-demo-button:hover {
  background: rgba(40, 40, 45, 0.85);
  border-color: rgba(204, 255, 0, 0.7);
  color: #CCFF00 !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
}

.mwg_effect006 .hero-modern-actions .hero-contact-button:not(.hero-demo-button):hover {
  background: #b8e600;
  color: #121212 !important;
  box-shadow: 0 6px 16px rgba(204, 255, 0, 0.35);
  text-shadow: none;
  transform: translateY(-1px);
}

.mwg_effect006 .hero-scrambled-text-wrapper {
  position: absolute;
  left: calc(4 * var(--vw));
  bottom: 8vh;
  z-index: 10;
  max-width: min(600px, calc(calc(100 * var(--vw)) - calc(8 * var(--vw))));
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.mwg_effect006 .hero-scrambled-text {
  position: relative;
  width: 100%;
  border-bottom: 1px dashed rgb(246, 246, 246);
  padding-bottom: 1.5vh;
  margin-bottom: 1.5vh;
}

.mwg_effect006 .hero-scrambled-text:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}


.mwg_effect006 .paragraph:not(:first-child) {
  position: relative;
  top: auto;
}

.mwg_effect006 .word {
  position: relative;
  overflow: hidden;
  display: inline-block;
  margin: -0.14em 0;
}

.mwg_effect006 .word span {
  display: block;
  padding: 0.14em 0;
}

.mwg_effect006 .paragraph:not(:first-child) .word span {
  transform: translateY(-100%);
}

.mwg_effect006 {
  font-family: "Satoshi", sans-serif;
  font-size: calc(3 * var(--vw)); /* ⬅ ukuran teks */
  line-height: 1; /* ⬅ penting buat GSAP word mask */
  letter-spacing: -0.03em;
}

/* Hero Paragraphs - Only for mobile overlay */
.mwg_effect006 .hero-paragraphs {
  display: none;
}

.mwg_effect006 .cta {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  box-sizing: border-box;
}

.mwg_effect006 .cta-main-group {
  position: absolute;
  right: calc(3 * var(--vw));
  top: 20vh;
  transform: translateY(40px);
  width: min(620px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(3 * var(--vw))));
  max-width: min(620px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(3 * var(--vw))));
  display: flex;
  flex-direction: column;
  gap: 16px;
  opacity: 0;
  will-change: transform, opacity;
}

.mwg_effect006 .cta-main,
.mwg_effect006 .cta-main-sub {
  font-size: clamp(18px, calc(1.8 * var(--vw)), 25px);
  line-height: 1.6;
  font-weight: 500;
  letter-spacing: 0;
  margin: 0;
}

/* Windows desktop adjustments for cta-main */
@media (max-width: 1366px) {
  .mwg_effect006 .cta-main-group {
    max-width: min(520px, calc(calc(100 * var(--vw)) - calc(52 * var(--vw)) - calc(3 * var(--vw))));
    width: min(520px, calc(calc(100 * var(--vw)) - calc(52 * var(--vw)) - calc(3 * var(--vw))));
    letter-spacing: 0;
  }

  .mwg_effect006 .cta-main,
  .mwg_effect006 .cta-main-sub {
    font-size: clamp(16px, calc(1.6 * var(--vw)), 22px);
    line-height: 1.6;
  }
}

/* Medium (641px - 1007px) */
@media (min-width: 641px) and (max-width: 1007px) {
  .mwg_effect006 .cta-main-group {
    max-width: min(480px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));
    width: min(480px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));
  }

  .mwg_effect006 .cta-main,
  .mwg_effect006 .cta-main-sub {
    font-size: clamp(15px, calc(1.7 * var(--vw)), 20px);
    line-height: 1.6;
  }
}

/* Small (<= 640px) */
@media (max-width: 640px) {
  .mwg_effect006 .cta-main-group {
    width: calc(90 * var(--vw));
    max-width: calc(90 * var(--vw));
  }

  .mwg_effect006 .cta-main,
  .mwg_effect006 .cta-main-sub {
    font-size: clamp(15px, calc(4 * var(--vw)), 18px);
    line-height: 1.5;
  }
}

.mwg_effect006 .cta-sub-wrapper {
  position: absolute;
  right: calc(2 * var(--vw));
  left: auto;
  bottom: 8vh;
  transform: translateY(40px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: calc(2 * var(--vw));
  opacity: 0;
  max-width: calc(72 * var(--vw));
}

.mwg_effect006 .cta-sub {
  font-size: clamp(26px, calc(2.6 * var(--vw)), 46px);
  line-height: 1.3;
  font-weight: 500;
  letter-spacing: 0;
  margin: 0;
}

.mwg_effect006 .cta-sub-secondary {
  font-size: clamp(18px, calc(1.8 * var(--vw)), 28px);
  line-height: 1.45;
  font-weight: 400;
}

.mwg_effect006 .cta-circular-text {
  flex-shrink: 0;
  width: 170px;
  height: 170px;
}
.mwg_effect006 .cta-circular-text .circular-text span {
  font-size: 20px;
}

/* Desktop Windows (<= 1366px) */
@media (max-width: 1366px) {
  .mwg_effect006 .cta-sub-wrapper {
    right: calc(2 * var(--vw));
    left: auto;
    bottom: 6vh;
    max-width: calc(68 * var(--vw));
    gap: calc(1.5 * var(--vw));
  }

  .mwg_effect006 .cta-sub {
    font-size: clamp(24px, calc(2.6 * var(--vw)), 38px);
    line-height: 1.3;
  }

  .mwg_effect006 .cta-sub-secondary {
    font-size: clamp(18px, calc(2 * var(--vw)), 28px);
  }

  .mwg_effect006 .cta-circular-text {
    width: 72px;
    height: 72px;
  }
  .mwg_effect006 .cta-circular-text .circular-text span {
    font-size: 14px;
  }
}

/* Small (<= 640px) */
@media (max-width: 640px) {
  .mwg_effect006 .cta-sub-wrapper {
    right: calc(4 * var(--vw));
    left: auto;
    bottom: 5vh;
    max-width: calc(90 * var(--vw));
    gap: 12px;
  }

  .mwg_effect006 .cta-sub {
    font-size: clamp(18px, calc(4.2 * var(--vw)), 24px);
    line-height: 1.3;
  }

  .mwg_effect006 .cta-sub-secondary {
    font-size: clamp(16px, calc(3.4 * var(--vw)), 20px);
    line-height: 1.4;
  }

  .mwg_effect006 .cta-circular-text {
    width: 52px;
    height: 52px;
  }
  .mwg_effect006 .cta-circular-text .circular-text span {
    font-size: 12px;
  }
}

/* Medium (641px - 1007px) */
@media (min-width: 641px) and (max-width: 1007px) {
  .mwg_effect006 .cta-sub-wrapper {
    right: calc(3 * var(--vw));
    left: auto;
    bottom: 6vh;
    max-width: calc(80 * var(--vw));
    gap: 16px;
  }

  .mwg_effect006 .cta-sub {
    font-size: clamp(22px, calc(3 * var(--vw)), 34px);
    line-height: 1.35;
  }

  .mwg_effect006 .cta-sub-secondary {
    font-size: clamp(18px, calc(2.4 * var(--vw)), 26px);
  }

  .mwg_effect006 .cta-circular-text {
    width: 64px;
    height: 64px;
  }
  .mwg_effect006 .cta-circular-text .circular-text span {
    font-size: 13px;
  }
}

/* Large (1008px - 1366px) */
@media (min-width: 1008px) and (max-width: 1366px) {
  .mwg_effect006 .cta-sub-wrapper {
    right: calc(2 * var(--vw));
    left: auto;
    bottom: 6vh;
    max-width: calc(70 * var(--vw));
    gap: calc(1.5 * var(--vw));
  }

  .mwg_effect006 .cta-sub {
    font-size: clamp(26px, calc(2.5 * var(--vw)), 36px);
    line-height: 1.3;
  }

  .mwg_effect006 .cta-sub-secondary {
    font-size: clamp(18px, calc(2 * var(--vw)), 26px);
  }

  .mwg_effect006 .cta-circular-text {
    width: 68px;
    height: 68px;
  }
  .mwg_effect006 .cta-circular-text .circular-text span {
    font-size: 14px;
  }
}

.mwg_effect006 .cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  padding: 18px 32px;
  border: 1px solid #673DE7;
  background: transparent;
  color: #673DE7;
  font-size: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mwg_effect006 .cta-btn:hover {
  background: #673DE7;
  color: #ffffff;
}

.mwg_effect006 .cta-btn span {
  font-size: 18px;
}

.mwg_effect006 .cta-mobile {
  display: none;
}

/* ==================== MEDIA QUERIES ==================== */

/* Tablet and below (max-width: 1024px) */
@media (max-width: 1024px) {
  .mwg_effect006 {
    font-size: calc(2.5 * var(--vw));
  }

  .mwg_effect006 .container {
    padding: 0;
  }

  .mwg_effect006 .left {
    width: 45%;
    padding-left: calc(15px + calc(2 * var(--vw)));
    padding-right: calc(2.5 * var(--vw));
    z-index: 10;
  }

  .mwg_effect006 .right {
    width: 100%;
    height: 100vh;
    border-radius: 0;
  }


  .mwg_effect006 .cta-main-group {
    right: calc(2 * var(--vw));
    width: min(600px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));
    max-width: min(600px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));
  }

  .mwg_effect006 .cta-main,
  .mwg_effect006 .cta-main-sub {
    font-size: calc(1.7 * var(--vw));
  }

  .mwg_effect006 .cta-sub-wrapper {
    left: calc(2 * var(--vw));
    bottom: 4vh;
  }

  .mwg_effect006 .cta-sub {
    font-size: calc(2.2 * var(--vw));
  }
}

/* Mobile (max-width: 768px) */
@media (max-width: 768px) {
  .mwg_effect006 {
    font-size: 18px;
  }

  .mwg_effect006 .hero-modern-actions {
    gap: 10px;
    flex-wrap: wrap;
  }

  .mwg_effect006 .hero-modern .navbar-contact-button {
    padding: 10px 16px;
    font-size: 14px;
  }

  .mwg_effect006 .pin-height {
    height: auto !important;
    min-height: auto;
  }

  .mwg_effect006 .container {
    flex-direction: column;
    justify-content: flex-start;
    padding: 0;
    gap: 0;
    height: 100vh;
    min-height: 100vh;
    position: relative !important;
  }

  .mwg_effect006 .left {
    display: none !important;
  }

  .mwg_effect006 .video-wrapper {
    position: relative;
    display: block;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  /* Hero Paragraphs Mobile - Slider */
  .mwg_effect006 .hero-paragraphs {
    display: none !important;
  }

  .mwg_effect006 .hero-paragraphs-mobile {
    position: absolute;
    bottom: 120px;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 0 calc(4 * var(--vw)) 0 calc(4 * var(--vw));
    box-sizing: border-box;
  }

  .mwg_effect006 .hero-paragraphs-slider {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-bottom: 20px;
    min-height: 100px;
  }

  .mwg_effect006 .hero-paragraphs-track {
    display: flex;
    width: 100%;
    will-change: transform;
  }

  .mwg_effect006 .hero-paragraph-slide {
    min-width: 100%;
    width: 100%;
    flex-shrink: 0;
    box-sizing: border-box;
  }

  .mwg_effect006 .hero-paragraph-slide .paragraph {
    font-size: 32px !important;
    font-weight: 500 !important;
    line-height: 1.4 !important;
    letter-spacing: -0.01em !important;
    margin: 0 !important;
    padding: 0 !important;
    color: #ffffff !important;
    text-align: left !important;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.9) !important;
  }

  .mwg_effect006 .hero-paragraphs-indicator {
    display: none !important;
  }

  .mwg_effect006 .video-wrapper::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.2) 30%, rgba(0, 0, 0, 0.5) 60%, rgba(0, 0, 0, 0.7) 100%);
    pointer-events: none;
    z-index: 1;
  }

  .mwg_effect006 .paragraph {
    position: relative !important;
    margin-bottom: 20px;
  }

  .mwg_effect006 .paragraph:not(:first-child) {
    position: relative !important;
    top: auto !important;
  }

  .mwg_effect006 .paragraph:not(:first-child) .word span {
    transform: translateY(0) !important;
  }

  .mwg_effect006 .video-wrapper .right {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0;
    transform: none !important;
    right: auto !important;
  }

  .mwg_effect006 .hero-scrambled-text-wrapper {
    left: calc(4 * var(--vw)) !important;
    bottom: 12vh !important;
    max-width: calc(calc(100 * var(--vw)) - calc(8 * var(--vw))) !important;
  }

  .mwg_effect006 .hero-scrambled-text {
    font-size: clamp(14px, calc(4 * var(--vw)), 20px) !important;
  }

  .mwg_effect006 .cta {
    position: absolute !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    top: auto !important;
    width: 100% !important;
    height: auto !important;
    padding: 20px calc(4 * var(--vw)) 5px !important;
    margin: 0 !important;
    z-index: 2 !important;
    background: transparent !important;
    pointer-events: auto !important;
    box-sizing: border-box !important;
  }

  .mwg_effect006 .cta-main,
  .mwg_effect006 .cta-sub-wrapper {
    display: none !important;
  }

  .mwg_effect006 .cta-mobile {
    display: block !important;
    position: absolute !important;
    bottom: 100px !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    padding: 30px calc(4 * var(--vw)) 0 !important;
    z-index: 2 !important;
    background: transparent !important;
    box-sizing: border-box !important;
  }

  .mwg_effect006 .cta-mobile-title {
    font-size: 34px !important;
    font-weight: 700 !important;
    line-height: 1.2 !important;
    color: #ffffff !important;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.8) !important;
    margin: 0 0 18px 0 !important;
    letter-spacing: -0.02em !important;
  }

  .mwg_effect006 .cta-mobile-desc {
    font-size: 19px !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    color: #ffffff !important;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.8) !important;
    margin: 0 0 24px 0 !important;
    opacity: 0.95 !important;
  }

  .mwg_effect006 .cta-mobile-btn {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 16px 28px !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #121212 !important;
    background-color: #CCFF00 !important;
    border: none !important;
    
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    text-decoration: none !important;
    box-shadow: 0 4px 12px rgba(204, 255, 0, 0.3) !important;
  }

  .mwg_effect006 .cta-mobile-btn:hover {
    background-color: #673DE7 !important;
    color: #ffffff !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 16px rgba(103, 61, 231, 0.4) !important;
  }

  .mwg_effect006 .cta-mobile-btn:active {
    transform: translateY(0) !important;
  }

  .mwg_effect006 .cta-btn {
    padding: 14px 24px;
    font-size: 12px;
  }

  .mwg_effect006 .cta-btn span {
    font-size: 16px;
  }
}

/* Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
  .mwg_effect006 {
    font-size: 16px;
  }

  .mwg_effect006 .hero-modern-actions {
    gap: 8px;
  }

  .mwg_effect006 .hero-modern .navbar-contact-button {
    padding: 9px 14px;
    font-size: 13px;
  }

  .mwg_effect006 .container {
    padding: 0;
    gap: 0;
  }

  .mwg_effect006 .left {
    display: none !important;
  }

  .mwg_effect006 .video-wrapper {
    height: 100vh;
  }

  .mwg_effect006 .video-wrapper .right {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .mwg_effect006 .hero-paragraphs-mobile {
    padding: 0 calc(4 * var(--vw)) 80px calc(4 * var(--vw));
  }

  .mwg_effect006 .hero-paragraph-slide .paragraph {
    font-size: 28px !important;
  }

  .mwg_effect006 .hero-paragraphs-indicator {
    display: none !important;
  }

  .mwg_effect006 .cta-main,
  .mwg_effect006 .cta-sub-wrapper {
    display: none !important;
  }

  .mwg_effect006 .cta-mobile {
    bottom: 80px !important;
  }

  .mwg_effect006 .cta-mobile-title {
    font-size: 28px !important;
  }

  .mwg_effect006 .cta-mobile-desc {
    font-size: 17px !important;
  }

  .mwg_effect006 .cta-mobile-btn {
    font-size: 17px !important;
    padding: 14px 24px !important;
  }

  .mwg_effect006 .cta-btn {
    padding: 12px 20px;
    font-size: 11px;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/hero/hero.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,UAAU;EACV,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,gDAAgD;EAChD,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,yEAAyE;EACzE,+CAA+C;EAC/C,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,2CAA2C;EAC3C;uCACqC;EACrC,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,wCAAwC;EACxC,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,wEAAwE;EACxE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4CAA4C;EAC5C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B,EAAE,kBAAkB;EAClD,cAAc,EAAE,kCAAkC;EAClD,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;EACT,2BAA2B;EAC3B,2FAA2F;EAC3F,+FAA+F;EAC/F,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,+BAA+B;AACjC;;AAEA;;EAEE,mDAAmD;EACnD,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE;IACE,+FAA+F;IAC/F,2FAA2F;IAC3F,iBAAiB;EACnB;;EAEA;;IAEE,mDAAmD;IACnD,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IAME,+FAA+F;IAC/F,2FAA2F;EAJ7F;;EAOA;;IAEE,mDAAmD;IACnD,gBAAgB;EAClB;AACF;;AAEA,qBAAqB;AACrB;EACE;IAME,2BAA2B;IAC3B,+BAA+B;EAJjC;;EAOA;;IAEE,iDAAiD;IACjD,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE;IACE,0BAA0B;IAC1B,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,mDAAmD;IACnD,gBAAgB;EAClB;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,0BAA0B;IAC1B,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,mDAAmD;IACnD,gBAAgB;EAClB;;EAEA;IACE,mDAAmD;IACnD,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,0BAA0B;IAC1B,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,iDAAiD;IACjD,iBAAiB;EACnB;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,0BAA0B;IAC1B,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,mDAAmD;IACnD,gBAAgB;EAClB;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,4DAA4D;;AAE5D,yCAAyC;AACzC;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,8CAA8C;IAC9C,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;;EAGA;IAOE,0BAA0B;IAC1B,2FAA2F;IAC3F,+FAA+F;EALjG;;EAQA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;IACV,MAAM;IACN,aAAa;IACb,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,WAAW;IACX,oDAAoD;IACpD,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;IAClC,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,kFAAkF;EACpF;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,+HAA+H;IAC/H,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,6BAA6B;IAC7B,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,uEAAuE;EACzE;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,gDAAgD;IAChD,oBAAoB;IACpB,qBAAqB;IACrB,kCAAkC;IAClC,+BAA+B;IAC/B,iCAAiC;EACnC;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,8CAA8C;IAC9C,qBAAqB;IACrB,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,kFAAkF;IAClF,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,kFAAkF;IAClF,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,oCAAoC;IACpC,uBAAuB;;IAEvB,0BAA0B;IAC1B,oCAAoC;IACpC,gCAAgC;IAChC,wDAAwD;EAC1D;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,sCAAsC;IACtC,yDAAyD;EAC3D;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,MAAM;EACR;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uDAAuD;EACzD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":[".mwg_effect006 {\n  letter-spacing: -0.03em;\n  overflow-x: hidden;\n  overflow-y: visible;\n  background-color: #D8D8D8;\n  color: #1E1E1E;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n}\n\n.mwg_effect006 .pin-height {\n  height: 400vh;\n}\n\n.mwg_effect006 .container {\n  height: 100vh;\n  padding: 0;\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  box-sizing: border-box;\n  position: relative;\n}\n\n.mwg_effect006 .name {\n  position: absolute;\n  top: 15vh;\n  left: calc(2 * 15px);\n}\n\n.mwg_effect006 .left {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 40%;\n  padding-left: calc(15px + calc(1.5 * var(--vw)));\n  padding-right: calc(3 * var(--vw));\n  z-index: 10;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.mwg_effect006 .left .paragraph {\n  color: #ffffff;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.9);\n}\n\n.mwg_effect006 .video-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n}\n\n.mwg_effect006 .right {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  object-fit: cover;\n  border-radius: 0;\n  z-index: 1;\n}\n\n.mwg_effect006 .hero-modern {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  pointer-events: none;\n}\n\n.mwg_effect006 .hero-modern-glass {\n  margin-left: calc(6 * var(--vw));\n  max-width: min(960px, calc(calc(100 * var(--vw)) - calc(12 * var(--vw))));\n  padding: clamp(18px, calc(2 * var(--vw)), 28px);\n  border-radius: 20px;\n  background: rgba(18, 18, 18, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);\n  /* backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px); */\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px;\n  pointer-events: auto;\n}\n\n.mwg_effect006 .hero-modern-inner {\n  color: #ffffff;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.mwg_effect006 .hero-modern-eyebrow {\n  font-size: clamp(14px, calc(1.1 * var(--vw)), 18px);\n  letter-spacing: 0.34em;\n  line-height: 1.6;\n  text-transform: uppercase;\n  opacity: 0.85;\n  margin: 0;\n}\n\n.mwg_effect006 .hero-modern-title {\n  font-size: clamp(35px, calc(3.5 * var(--vw)), 62px);\n  line-height: 1.05;\n  letter-spacing: 0.025em;\n  margin: 0;\n}\n\n.mwg_effect006 .hero-modern-subtitle {\n  font-size: clamp(16px, calc(1.4 * var(--vw)), 20px);\n  line-height: 1.5;\n  letter-spacing: 0.02em;\n  margin: 0;\n  opacity: 0.9;\n}\n\n.mwg_effect006 .hero-modern-highlight {\n  font-weight: 700;\n  color: #CCFF00;\n}\n\n.mwg_effect006 .hero-modern-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 6px;\n  pointer-events: auto;\n}\n\n.mwg_effect006 .hero-persona-row {\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  color: #cfcfe6;\n}\n\n.mwg_effect006 .hero-persona-avatars {\n  display: flex;\n  align-items: center;\n}\n\n.mwg_effect006 .hero-persona-avatars img {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  border: 2px solid rgba(255, 255, 255, 0.85);\n  object-fit: cover;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);\n}\n\n.mwg_effect006 .hero-persona-avatars img + img {\n  margin-left: -12px;\n}\n\n.mwg_effect006 .hero-persona-count {\n  min-width: 44px;\n  height: 44px;\n  border-radius: 999px;\n  background: #d9cff7;\n  color: #4a3ea3;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.mwg_effect006 .hero-persona-text {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.mwg_effect006 .hero-modern-metrics {\n    display: flex;\n    gap: 24px;\n    margin-top: 50px;\n    opacity: 0.9;\n}\n\n.mwg_effect006 .hero-modern-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.mwg_effect006 .hero-modern-metric-value {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.mwg_effect006 .hero-modern-metric-label {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.26em;\n}\n\n.mwg_effect006 .hero-modern .navbar-contact-button {\n  letter-spacing: 0.08em;\n}\n\n.mwg_effect006 .hero-modern-actions .hero-contact-button:not(.hero-demo-button) {\n  text-shadow: none;\n}\n\n.mwg_effect006 .hero-modern-actions .hero-demo-button {\n  background: rgba(18, 18, 18, 0.35);\n  color: #CCFF00 !important;\n  border: 1px solid rgba(204, 255, 0, 0.5);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.mwg_effect006 .hero-modern-actions .hero-demo-button:hover {\n  background: rgba(40, 40, 45, 0.85);\n  border-color: rgba(204, 255, 0, 0.7);\n  color: #CCFF00 !important;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\n  transform: translateY(-1px);\n}\n\n.mwg_effect006 .hero-modern-actions .hero-contact-button:not(.hero-demo-button):hover {\n  background: #b8e600;\n  color: #121212 !important;\n  box-shadow: 0 6px 16px rgba(204, 255, 0, 0.35);\n  text-shadow: none;\n  transform: translateY(-1px);\n}\n\n.mwg_effect006 .hero-scrambled-text-wrapper {\n  position: absolute;\n  left: calc(4 * var(--vw));\n  bottom: 8vh;\n  z-index: 10;\n  max-width: min(600px, calc(calc(100 * var(--vw)) - calc(8 * var(--vw))));\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.mwg_effect006 .hero-scrambled-text {\n  position: relative;\n  width: 100%;\n  border-bottom: 1px dashed rgb(246, 246, 246);\n  padding-bottom: 1.5vh;\n  margin-bottom: 1.5vh;\n}\n\n.mwg_effect006 .hero-scrambled-text:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n\n.mwg_effect006 .paragraph:not(:first-child) {\n  position: relative;\n  top: auto;\n}\n\n.mwg_effect006 .word {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  margin: -0.14em 0;\n}\n\n.mwg_effect006 .word span {\n  display: block;\n  padding: 0.14em 0;\n}\n\n.mwg_effect006 .paragraph:not(:first-child) .word span {\n  transform: translateY(-100%);\n}\n\n.mwg_effect006 {\n  font-family: \"Satoshi\", sans-serif;\n  font-size: calc(3 * var(--vw)); /* ⬅ ukuran teks */\n  line-height: 1; /* ⬅ penting buat GSAP word mask */\n  letter-spacing: -0.03em;\n}\n\n/* Hero Paragraphs - Only for mobile overlay */\n.mwg_effect006 .hero-paragraphs {\n  display: none;\n}\n\n.mwg_effect006 .cta {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n.mwg_effect006 .cta-main-group {\n  position: absolute;\n  right: calc(3 * var(--vw));\n  top: 20vh;\n  transform: translateY(40px);\n  width: min(620px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(3 * var(--vw))));\n  max-width: min(620px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(3 * var(--vw))));\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  opacity: 0;\n  will-change: transform, opacity;\n}\n\n.mwg_effect006 .cta-main,\n.mwg_effect006 .cta-main-sub {\n  font-size: clamp(18px, calc(1.8 * var(--vw)), 25px);\n  line-height: 1.6;\n  font-weight: 500;\n  letter-spacing: 0;\n  margin: 0;\n}\n\n/* Windows desktop adjustments for cta-main */\n@media (max-width: 1366px) {\n  .mwg_effect006 .cta-main-group {\n    max-width: min(520px, calc(calc(100 * var(--vw)) - calc(52 * var(--vw)) - calc(3 * var(--vw))));\n    width: min(520px, calc(calc(100 * var(--vw)) - calc(52 * var(--vw)) - calc(3 * var(--vw))));\n    letter-spacing: 0;\n  }\n\n  .mwg_effect006 .cta-main,\n  .mwg_effect006 .cta-main-sub {\n    font-size: clamp(16px, calc(1.6 * var(--vw)), 22px);\n    line-height: 1.6;\n  }\n}\n\n/* Medium (641px - 1007px) */\n@media (min-width: 641px) and (max-width: 1007px) {\n  .mwg_effect006 .cta-main-group {\n    max-width: min(480px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));\n    width: min(480px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));\n  }\n\n  .mwg_effect006 .cta-main-group {\n    max-width: min(480px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));\n    width: min(480px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));\n  }\n\n  .mwg_effect006 .cta-main,\n  .mwg_effect006 .cta-main-sub {\n    font-size: clamp(15px, calc(1.7 * var(--vw)), 20px);\n    line-height: 1.6;\n  }\n}\n\n/* Small (<= 640px) */\n@media (max-width: 640px) {\n  .mwg_effect006 .cta-main-group {\n    max-width: calc(90 * var(--vw));\n    width: calc(90 * var(--vw));\n  }\n\n  .mwg_effect006 .cta-main-group {\n    width: calc(90 * var(--vw));\n    max-width: calc(90 * var(--vw));\n  }\n\n  .mwg_effect006 .cta-main,\n  .mwg_effect006 .cta-main-sub {\n    font-size: clamp(15px, calc(4 * var(--vw)), 18px);\n    line-height: 1.5;\n  }\n}\n\n.mwg_effect006 .cta-sub-wrapper {\n  position: absolute;\n  right: calc(2 * var(--vw));\n  left: auto;\n  bottom: 8vh;\n  transform: translateY(40px);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: calc(2 * var(--vw));\n  opacity: 0;\n  max-width: calc(72 * var(--vw));\n}\n\n.mwg_effect006 .cta-sub {\n  font-size: clamp(26px, calc(2.6 * var(--vw)), 46px);\n  line-height: 1.3;\n  font-weight: 500;\n  letter-spacing: 0;\n  margin: 0;\n}\n\n.mwg_effect006 .cta-sub-secondary {\n  font-size: clamp(18px, calc(1.8 * var(--vw)), 28px);\n  line-height: 1.45;\n  font-weight: 400;\n}\n\n.mwg_effect006 .cta-circular-text {\n  flex-shrink: 0;\n  width: 170px;\n  height: 170px;\n}\n.mwg_effect006 .cta-circular-text .circular-text span {\n  font-size: 20px;\n}\n\n/* Desktop Windows (<= 1366px) */\n@media (max-width: 1366px) {\n  .mwg_effect006 .cta-sub-wrapper {\n    right: calc(2 * var(--vw));\n    left: auto;\n    bottom: 6vh;\n    max-width: calc(68 * var(--vw));\n    gap: calc(1.5 * var(--vw));\n  }\n\n  .mwg_effect006 .cta-sub {\n    font-size: clamp(24px, calc(2.6 * var(--vw)), 38px);\n    line-height: 1.3;\n  }\n\n  .mwg_effect006 .cta-sub-secondary {\n    font-size: clamp(18px, calc(2 * var(--vw)), 28px);\n  }\n\n  .mwg_effect006 .cta-circular-text {\n    width: 72px;\n    height: 72px;\n  }\n  .mwg_effect006 .cta-circular-text .circular-text span {\n    font-size: 14px;\n  }\n}\n\n/* Small (<= 640px) */\n@media (max-width: 640px) {\n  .mwg_effect006 .cta-sub-wrapper {\n    right: calc(4 * var(--vw));\n    left: auto;\n    bottom: 5vh;\n    max-width: calc(90 * var(--vw));\n    gap: 12px;\n  }\n\n  .mwg_effect006 .cta-sub {\n    font-size: clamp(18px, calc(4.2 * var(--vw)), 24px);\n    line-height: 1.3;\n  }\n\n  .mwg_effect006 .cta-sub-secondary {\n    font-size: clamp(16px, calc(3.4 * var(--vw)), 20px);\n    line-height: 1.4;\n  }\n\n  .mwg_effect006 .cta-circular-text {\n    width: 52px;\n    height: 52px;\n  }\n  .mwg_effect006 .cta-circular-text .circular-text span {\n    font-size: 12px;\n  }\n}\n\n/* Medium (641px - 1007px) */\n@media (min-width: 641px) and (max-width: 1007px) {\n  .mwg_effect006 .cta-sub-wrapper {\n    right: calc(3 * var(--vw));\n    left: auto;\n    bottom: 6vh;\n    max-width: calc(80 * var(--vw));\n    gap: 16px;\n  }\n\n  .mwg_effect006 .cta-sub {\n    font-size: clamp(22px, calc(3 * var(--vw)), 34px);\n    line-height: 1.35;\n  }\n\n  .mwg_effect006 .cta-sub-secondary {\n    font-size: clamp(18px, calc(2.4 * var(--vw)), 26px);\n  }\n\n  .mwg_effect006 .cta-circular-text {\n    width: 64px;\n    height: 64px;\n  }\n  .mwg_effect006 .cta-circular-text .circular-text span {\n    font-size: 13px;\n  }\n}\n\n/* Large (1008px - 1366px) */\n@media (min-width: 1008px) and (max-width: 1366px) {\n  .mwg_effect006 .cta-sub-wrapper {\n    right: calc(2 * var(--vw));\n    left: auto;\n    bottom: 6vh;\n    max-width: calc(70 * var(--vw));\n    gap: calc(1.5 * var(--vw));\n  }\n\n  .mwg_effect006 .cta-sub {\n    font-size: clamp(26px, calc(2.5 * var(--vw)), 36px);\n    line-height: 1.3;\n  }\n\n  .mwg_effect006 .cta-sub-secondary {\n    font-size: clamp(18px, calc(2 * var(--vw)), 26px);\n  }\n\n  .mwg_effect006 .cta-circular-text {\n    width: 68px;\n    height: 68px;\n  }\n  .mwg_effect006 .cta-circular-text .circular-text span {\n    font-size: 14px;\n  }\n}\n\n.mwg_effect006 .cta-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 32px;\n  border: 1px solid #673DE7;\n  background: transparent;\n  color: #673DE7;\n  font-size: 14px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.mwg_effect006 .cta-btn:hover {\n  background: #673DE7;\n  color: #ffffff;\n}\n\n.mwg_effect006 .cta-btn span {\n  font-size: 18px;\n}\n\n.mwg_effect006 .cta-mobile {\n  display: none;\n}\n\n/* ==================== MEDIA QUERIES ==================== */\n\n/* Tablet and below (max-width: 1024px) */\n@media (max-width: 1024px) {\n  .mwg_effect006 {\n    font-size: calc(2.5 * var(--vw));\n  }\n\n  .mwg_effect006 .container {\n    padding: 0;\n  }\n\n  .mwg_effect006 .left {\n    width: 45%;\n    padding-left: calc(15px + calc(2 * var(--vw)));\n    padding-right: calc(2.5 * var(--vw));\n    z-index: 10;\n  }\n\n  .mwg_effect006 .right {\n    width: 100%;\n    height: 100vh;\n    border-radius: 0;\n  }\n\n\n  .mwg_effect006 .cta-main-group {\n    right: calc(2 * var(--vw));\n    width: min(600px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));\n    max-width: min(600px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));\n  }\n\n  .mwg_effect006 .cta-main-group {\n    right: calc(2 * var(--vw));\n    width: min(600px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));\n    max-width: min(600px, calc(calc(100 * var(--vw)) - calc(50 * var(--vw)) - calc(2 * var(--vw))));\n  }\n\n  .mwg_effect006 .cta-main,\n  .mwg_effect006 .cta-main-sub {\n    font-size: calc(1.7 * var(--vw));\n  }\n\n  .mwg_effect006 .cta-sub-wrapper {\n    left: calc(2 * var(--vw));\n    bottom: 4vh;\n  }\n\n  .mwg_effect006 .cta-sub {\n    font-size: calc(2.2 * var(--vw));\n  }\n}\n\n/* Mobile (max-width: 768px) */\n@media (max-width: 768px) {\n  .mwg_effect006 {\n    font-size: 18px;\n  }\n\n  .mwg_effect006 .hero-modern-actions {\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n\n  .mwg_effect006 .hero-modern .navbar-contact-button {\n    padding: 10px 16px;\n    font-size: 14px;\n  }\n\n  .mwg_effect006 .pin-height {\n    height: auto !important;\n    min-height: auto;\n  }\n\n  .mwg_effect006 .container {\n    flex-direction: column;\n    justify-content: flex-start;\n    padding: 0;\n    gap: 0;\n    height: 100vh;\n    min-height: 100vh;\n    position: relative !important;\n  }\n\n  .mwg_effect006 .left {\n    display: none !important;\n  }\n\n  .mwg_effect006 .video-wrapper {\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n  }\n\n  /* Hero Paragraphs Mobile - Slider */\n  .mwg_effect006 .hero-paragraphs {\n    display: none !important;\n  }\n\n  .mwg_effect006 .hero-paragraphs-mobile {\n    position: absolute;\n    bottom: 120px;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    padding: 0 calc(4 * var(--vw)) 0 calc(4 * var(--vw));\n    box-sizing: border-box;\n  }\n\n  .mwg_effect006 .hero-paragraphs-slider {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    margin-bottom: 20px;\n    min-height: 100px;\n  }\n\n  .mwg_effect006 .hero-paragraphs-track {\n    display: flex;\n    width: 100%;\n    will-change: transform;\n  }\n\n  .mwg_effect006 .hero-paragraph-slide {\n    min-width: 100%;\n    width: 100%;\n    flex-shrink: 0;\n    box-sizing: border-box;\n  }\n\n  .mwg_effect006 .hero-paragraph-slide .paragraph {\n    font-size: 32px !important;\n    font-weight: 500 !important;\n    line-height: 1.4 !important;\n    letter-spacing: -0.01em !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    color: #ffffff !important;\n    text-align: left !important;\n    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.9) !important;\n  }\n\n  .mwg_effect006 .hero-paragraphs-indicator {\n    display: none !important;\n  }\n\n  .mwg_effect006 .video-wrapper::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 50%;\n    background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.2) 30%, rgba(0, 0, 0, 0.5) 60%, rgba(0, 0, 0, 0.7) 100%);\n    pointer-events: none;\n    z-index: 1;\n  }\n\n  .mwg_effect006 .paragraph {\n    position: relative !important;\n    margin-bottom: 20px;\n  }\n\n  .mwg_effect006 .paragraph:not(:first-child) {\n    position: relative !important;\n    top: auto !important;\n  }\n\n  .mwg_effect006 .paragraph:not(:first-child) .word span {\n    transform: translateY(0) !important;\n  }\n\n  .mwg_effect006 .video-wrapper .right {\n    position: absolute !important;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 0;\n    transform: none !important;\n    right: auto !important;\n  }\n\n  .mwg_effect006 .hero-scrambled-text-wrapper {\n    left: calc(4 * var(--vw)) !important;\n    bottom: 12vh !important;\n    max-width: calc(calc(100 * var(--vw)) - calc(8 * var(--vw))) !important;\n  }\n\n  .mwg_effect006 .hero-scrambled-text {\n    font-size: clamp(14px, calc(4 * var(--vw)), 20px) !important;\n  }\n\n  .mwg_effect006 .cta {\n    position: absolute !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    top: auto !important;\n    width: 100% !important;\n    height: auto !important;\n    padding: 20px calc(4 * var(--vw)) 5px !important;\n    margin: 0 !important;\n    z-index: 2 !important;\n    background: transparent !important;\n    pointer-events: auto !important;\n    box-sizing: border-box !important;\n  }\n\n  .mwg_effect006 .cta-main,\n  .mwg_effect006 .cta-sub-wrapper {\n    display: none !important;\n  }\n\n  .mwg_effect006 .cta-mobile {\n    display: block !important;\n    position: absolute !important;\n    bottom: 100px !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: 100% !important;\n    padding: 30px calc(4 * var(--vw)) 0 !important;\n    z-index: 2 !important;\n    background: transparent !important;\n    box-sizing: border-box !important;\n  }\n\n  .mwg_effect006 .cta-mobile-title {\n    font-size: 34px !important;\n    font-weight: 700 !important;\n    line-height: 1.2 !important;\n    color: #ffffff !important;\n    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.8) !important;\n    margin: 0 0 18px 0 !important;\n    letter-spacing: -0.02em !important;\n  }\n\n  .mwg_effect006 .cta-mobile-desc {\n    font-size: 19px !important;\n    font-weight: 400 !important;\n    line-height: 1.5 !important;\n    color: #ffffff !important;\n    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.8) !important;\n    margin: 0 0 24px 0 !important;\n    opacity: 0.95 !important;\n  }\n\n  .mwg_effect006 .cta-mobile-btn {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    padding: 16px 28px !important;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    color: #121212 !important;\n    background-color: #CCFF00 !important;\n    border: none !important;\n    \n    cursor: pointer !important;\n    transition: all 0.3s ease !important;\n    text-decoration: none !important;\n    box-shadow: 0 4px 12px rgba(204, 255, 0, 0.3) !important;\n  }\n\n  .mwg_effect006 .cta-mobile-btn:hover {\n    background-color: #673DE7 !important;\n    color: #ffffff !important;\n    transform: translateY(-2px) !important;\n    box-shadow: 0 6px 16px rgba(103, 61, 231, 0.4) !important;\n  }\n\n  .mwg_effect006 .cta-mobile-btn:active {\n    transform: translateY(0) !important;\n  }\n\n  .mwg_effect006 .cta-btn {\n    padding: 14px 24px;\n    font-size: 12px;\n  }\n\n  .mwg_effect006 .cta-btn span {\n    font-size: 16px;\n  }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media (max-width: 480px) {\n  .mwg_effect006 {\n    font-size: 16px;\n  }\n\n  .mwg_effect006 .hero-modern-actions {\n    gap: 8px;\n  }\n\n  .mwg_effect006 .hero-modern .navbar-contact-button {\n    padding: 9px 14px;\n    font-size: 13px;\n  }\n\n  .mwg_effect006 .container {\n    padding: 0;\n    gap: 0;\n  }\n\n  .mwg_effect006 .left {\n    display: none !important;\n  }\n\n  .mwg_effect006 .video-wrapper {\n    height: 100vh;\n  }\n\n  .mwg_effect006 .video-wrapper .right {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n\n  .mwg_effect006 .hero-paragraphs-mobile {\n    padding: 0 calc(4 * var(--vw)) 80px calc(4 * var(--vw));\n  }\n\n  .mwg_effect006 .hero-paragraph-slide .paragraph {\n    font-size: 28px !important;\n  }\n\n  .mwg_effect006 .hero-paragraphs-indicator {\n    display: none !important;\n  }\n\n  .mwg_effect006 .cta-main,\n  .mwg_effect006 .cta-sub-wrapper {\n    display: none !important;\n  }\n\n  .mwg_effect006 .cta-mobile {\n    bottom: 80px !important;\n  }\n\n  .mwg_effect006 .cta-mobile-title {\n    font-size: 28px !important;\n  }\n\n  .mwg_effect006 .cta-mobile-desc {\n    font-size: 17px !important;\n  }\n\n  .mwg_effect006 .cta-mobile-btn {\n    font-size: 17px !important;\n    padding: 14px 24px !important;\n  }\n\n  .mwg_effect006 .cta-btn {\n    padding: 12px 20px;\n    font-size: 11px;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
